webpackJsonp([48183455387527],{

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _helpers = __webpack_require__(35);
	
	var _Paper = _interopRequireDefault(__webpack_require__(78));
	
	// @inheritedComponent Paper
	var styles = function styles(theme) {
	  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
	  return {
	    root: {
	      display: 'flex',
	      flexDirection: 'column',
	      width: '100%',
	      boxSizing: 'border-box',
	      // Prevent padding issue with the Modal and fixed positioned AppBar.
	      zIndex: theme.zIndex.appBar,
	      flexShrink: 0
	    },
	    positionFixed: {
	      position: 'fixed',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	    positionAbsolute: {
	      position: 'absolute',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	    positionSticky: {
	      position: 'sticky',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	    positionStatic: {
	      position: 'static'
	    },
	    colorDefault: {
	      backgroundColor: backgroundColorDefault,
	      color: theme.palette.getContrastText(backgroundColorDefault)
	    },
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    }
	  };
	};
	
	exports.styles = styles;
	
	function AppBar(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      position = props.position,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "position"]);
	  var className = (0, _classnames.default)(classes.root, classes["position".concat((0, _helpers.capitalize)(position))], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, 'mui-fixed', position === 'fixed'), _classNames), classNameProp);
	  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    component: "header",
	    elevation: 4,
	    className: className
	  }, other), children);
	}
	
	AppBar.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'default']),
	
	  /**
	   * The positioning type. The behavior of the different options is described
	   * [here](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
	   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
	   */
	  position: _propTypes.default.oneOf(['fixed', 'absolute', 'sticky', 'static'])
	} : {};
	AppBar.defaultProps = {
	  color: 'primary',
	  position: 'fixed'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAppBar'
	})(AppBar);
	
	exports.default = _default;

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _AppBar.default;
	  }
	});
	
	var _AppBar = _interopRequireDefault(__webpack_require__(154));

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.default;
	  }
	});
	
	var _Avatar = _interopRequireDefault(__webpack_require__(421));

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var styles = function styles(theme) {
	  return {
	    root: theme.mixins.gutters({
	      paddingTop: theme.spacing.unit * 2,
	      paddingBottom: theme.spacing.unit * 2,
	      '&:last-child': {
	        paddingBottom: theme.spacing.unit * 3
	      }
	    })
	  };
	};
	
	exports.styles = styles;
	
	function CardContent(props) {
	  var classes = props.classes,
	      className = props.className,
	      Component = props.component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, className)
	  }, other));
	}
	
	CardContent.propTypes =  false ? {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
	} : {};
	CardContent.defaultProps = {
	  component: 'div'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardContent'
	})(CardContent);
	
	exports.default = _default;

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardContent.default;
	  }
	});
	
	var _CardContent = _interopRequireDefault(__webpack_require__(235));

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(19));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _helpers = __webpack_require__(35);
	
	var SIZE = 50;
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  return (clampedValue - min) / (max - min);
	}
	
	function easeOut(t) {
	  t = getRelativeValue(t, 0, 1); // https://gist.github.com/gre/1650294
	
	  t = (t -= 1) * t * t + 1;
	  return t;
	}
	
	function easeIn(t) {
	  return t * t;
	}
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'inline-block'
	    },
	    static: {
	      transition: theme.transitions.create('transform')
	    },
	    indeterminate: {
	      animation: 'mui-progress-circular-rotate 1.4s linear infinite'
	    },
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	    svg: {},
	    circle: {
	      stroke: 'currentColor',
	      strokeLinecap: 'round'
	    },
	    circleStatic: {
	      transition: theme.transitions.create('stroke-dashoffset')
	    },
	    circleIndeterminate: {
	      animation: 'mui-progress-circular-dash 1.4s ease-in-out infinite',
	      // Some default value that looks fine waiting for the animation to kicks in.
	      strokeDasharray: '80px, 200px',
	      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
	
	    },
	    '@keyframes mui-progress-circular-rotate': {
	      '100%': {
	        transform: 'rotate(360deg)'
	      }
	    },
	    '@keyframes mui-progress-circular-dash': {
	      '0%': {
	        strokeDasharray: '1px, 200px',
	        strokeDashoffset: '0px'
	      },
	      '50%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-15px'
	      },
	      '100%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-120px'
	      }
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	
	function CircularProgress(props) {
	  var _classNames, _classNames2;
	
	  var classes = props.classes,
	      className = props.className,
	      color = props.color,
	      size = props.size,
	      style = props.style,
	      thickness = props.thickness,
	      value = props.value,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "size", "style", "thickness", "value", "variant"]);
	  var circleStyle = {};
	  var rootStyle = {};
	  var rootProps = {};
	
	  if (variant === 'determinate' || variant === 'static') {
	    var circumference = 2 * Math.PI * (SIZE / 2 - 5);
	    circleStyle.strokeDasharray = circumference.toFixed(3);
	    rootProps['aria-valuenow'] = Math.round(value);
	
	    if (variant === 'static') {
	      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
	      rootStyle.transform = 'rotate(-90deg)';
	    } else {
	      circleStyle.strokeDashoffset = "".concat((easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
	      rootStyle.transform = "rotate(".concat((easeOut(value / 70) * 270).toFixed(3), "deg)");
	    }
	  }
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes.indeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames, classes.static, variant === 'static'), _classNames), className),
	    style: (0, _objectSpread2.default)({
	      width: size,
	      height: size
	    }, rootStyle, style),
	    role: "progressbar"
	  }, rootProps, other), _react.default.createElement("svg", {
	    className: classes.svg,
	    viewBox: "0 0 ".concat(SIZE, " ").concat(SIZE)
	  }, _react.default.createElement("circle", {
	    className: (0, _classnames.default)(classes.circle, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.circleIndeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames2, classes.circleStatic, variant === 'static'), _classNames2)),
	    style: circleStyle,
	    cx: SIZE / 2,
	    cy: SIZE / 2,
	    r: SIZE / 2 - 5,
	    fill: "none",
	    strokeWidth: thickness
	  })));
	}
	
	CircularProgress.propTypes =  false ? {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary', 'inherit']),
	
	  /**
	   * The size of the circle.
	   */
	  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The thickness of the circle.
	   */
	  thickness: _propTypes.default.number,
	
	  /**
	   * The value of the progress indicator for the determinate and static variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The variant of progress indicator. Use indeterminate
	   * when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'static'])
	} : {};
	CircularProgress.defaultProps = {
	  color: 'primary',
	  size: 40,
	  thickness: 3.6,
	  value: 0,
	  variant: 'indeterminate'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCircularProgress',
	  flip: false
	})(CircularProgress);
	
	exports.default = _default;

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CircularProgress.default;
	  }
	});
	
	var _CircularProgress = _interopRequireDefault(__webpack_require__(237));

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(19));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(94));
	
	var _reactHelpers = __webpack_require__(168);
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      justifyContent: 'flex-start',
	      alignItems: 'center',
	      position: 'relative',
	      textDecoration: 'none',
	      width: '100%',
	      boxSizing: 'border-box',
	      textAlign: 'left'
	    },
	    container: {
	      position: 'relative'
	    },
	    focusVisible: {
	      backgroundColor: theme.palette.action.hover
	    },
	    default: {
	      paddingTop: 12,
	      paddingBottom: 12
	    },
	    dense: {
	      paddingTop: theme.spacing.unit,
	      paddingBottom: theme.spacing.unit
	    },
	    disabled: {
	      opacity: 0.5
	    },
	    divider: {
	      borderBottom: "1px solid ".concat(theme.palette.divider),
	      backgroundClip: 'padding-box'
	    },
	    gutters: theme.mixins.gutters(),
	    button: {
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: theme.palette.action.hover,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	    secondaryAction: {
	      // Add some space to avoid collision as `ListItemSecondaryAction`
	      // is absolutely positionned.
	      paddingRight: theme.spacing.unit * 4
	    }
	  };
	};
	
	exports.styles = styles;
	
	var ListItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ListItem, _React$Component);
	
	  function ListItem() {
	    (0, _classCallCheck2.default)(this, ListItem);
	    return (0, _possibleConstructorReturn2.default)(this, (ListItem.__proto__ || (0, _getPrototypeOf.default)(ListItem)).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(ListItem, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        dense: this.props.dense || this.context.dense || false
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          button = _props.button,
	          childrenProp = _props.children,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          componentProp = _props.component,
	          ContainerComponent = _props.ContainerComponent,
	          _props$ContainerProps = _props.ContainerProps;
	      _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
	      var ContainerClassName = _props$ContainerProps.className,
	          ContainerProps = (0, _objectWithoutProperties2.default)(_props$ContainerProps, ["className"]),
	          dense = _props.dense,
	          disabled = _props.disabled,
	          disableGutters = _props.disableGutters,
	          divider = _props.divider,
	          other = (0, _objectWithoutProperties2.default)(_props, ["button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider"]);
	      var isDense = dense || this.context.dense || false;
	
	      var children = _react.default.Children.toArray(childrenProp);
	
	      var hasAvatar = children.some(function (value) {
	        return (0, _reactHelpers.isMuiElement)(value, ['ListItemAvatar']);
	      });
	      var hasSecondaryAction = children.length && (0, _reactHelpers.isMuiElement)(children[children.length - 1], ['ListItemSecondaryAction']);
	      var className = (0, _classnames.default)(classes.root, isDense || hasAvatar ? classes.dense : classes.default, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.gutters, !disableGutters), (0, _defineProperty2.default)(_classNames, classes.divider, divider), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.button, button), (0, _defineProperty2.default)(_classNames, classes.secondaryAction, hasSecondaryAction), _classNames), classNameProp);
	      var componentProps = (0, _objectSpread2.default)({
	        className: className,
	        disabled: disabled
	      }, other);
	      var Component = componentProp || 'li';
	
	      if (button) {
	        componentProps.component = componentProp || 'div';
	        componentProps.focusVisibleClassName = classes.focusVisible;
	        Component = _ButtonBase.default;
	      }
	
	      if (hasSecondaryAction) {
	        // Use div by default.
	        Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.
	
	        if (ContainerComponent === 'li') {
	          if (Component === 'li') {
	            Component = 'div';
	          } else if (componentProps.component === 'li') {
	            componentProps.component = 'div';
	          }
	        }
	
	        return _react.default.createElement(ContainerComponent, (0, _extends2.default)({
	          className: (0, _classnames.default)(classes.container, ContainerClassName)
	        }, ContainerProps), _react.default.createElement(Component, componentProps, children), children.pop());
	      }
	
	      return _react.default.createElement(Component, componentProps, children);
	    }
	  }]);
	  return ListItem;
	}(_react.default.Component);
	
	ListItem.propTypes =  false ? {
	  /**
	   * If `true`, the list item will be a button (using `ButtonBase`).
	   */
	  button: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * The container component used when a `ListItemSecondaryAction` is rendered.
	   */
	  ContainerComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Properties applied to the container element when the component
	   * is used to display a `ListItemSecondaryAction`.
	   */
	  ContainerProps: _propTypes.default.object,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * If `true`, a 1px light border is added to the bottom of the list item.
	   */
	  divider: _propTypes.default.bool
	} : {};
	ListItem.defaultProps = {
	  button: false,
	  ContainerComponent: 'li',
	  dense: false,
	  disabled: false,
	  disableGutters: false,
	  divider: false
	};
	ListItem.contextTypes = {
	  dense: _propTypes.default.bool
	};
	ListItem.childContextTypes = {
	  dense: _propTypes.default.bool
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItem'
	})(ListItem);
	
	exports.default = _default;

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItem.default;
	  }
	});
	
	var _ListItem = _interopRequireDefault(__webpack_require__(443));

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _Typography = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      flex: '1 1 auto',
	      minWidth: 0,
	      padding: "0 ".concat(theme.spacing.unit * 2, "px"),
	      '&:first-child': {
	        paddingLeft: 0
	      }
	    },
	    inset: {
	      '&:first-child': {
	        paddingLeft: theme.spacing.unit * 7
	      }
	    },
	    dense: {
	      fontSize: theme.typography.pxToRem(13)
	    },
	    primary: {
	      '&$textDense': {
	        fontSize: 'inherit'
	      }
	    },
	    secondary: {
	      '&$textDense': {
	        fontSize: 'inherit'
	      }
	    },
	    textDense: {}
	  };
	};
	
	exports.styles = styles;
	
	function ListItemText(props, context) {
	  var _classNames3;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      disableTypography = props.disableTypography,
	      inset = props.inset,
	      primaryProp = props.primary,
	      secondaryProp = props.secondary,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "secondary"]);
	  var dense = context.dense;
	  var primary = primaryProp || children;
	
	  if (primary && !disableTypography) {
	    primary = _react.default.createElement(_Typography.default, {
	      variant: "subheading",
	      className: (0, _classnames.default)(classes.primary, (0, _defineProperty2.default)({}, classes.textDense, dense))
	    }, primary);
	  }
	
	  var secondary = secondaryProp;
	
	  if (secondary && !disableTypography) {
	    secondary = _react.default.createElement(_Typography.default, {
	      variant: "body1",
	      className: (0, _classnames.default)(classes.secondary, (0, _defineProperty2.default)({}, classes.textDense, dense)),
	      color: "textSecondary"
	    }, secondary);
	  }
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.dense, dense), (0, _defineProperty2.default)(_classNames3, classes.inset, inset), _classNames3), classNameProp)
	  }, other), primary, secondary);
	}
	
	ListItemText.propTypes =  false ? {
	  /**
	   * Alias for the `primary` property.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the children won't be wrapped by a typography component.
	   * For instance, that can be useful to can render an h4 instead of a
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * If `true`, the children will be indented.
	   * This should be used if there is no left avatar or left icon.
	   */
	  inset: _propTypes.default.bool,
	  primary: _propTypes.default.node,
	  secondary: _propTypes.default.node
	} : {};
	ListItemText.defaultProps = {
	  disableTypography: false,
	  inset: false
	};
	ListItemText.contextTypes = {
	  dense: _propTypes.default.bool
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemText'
	})(ListItemText);
	
	exports.default = _default;

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemText.default;
	  }
	});
	
	var _ListItemText = _interopRequireDefault(__webpack_require__(445));

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(19));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var styles = function styles(theme) {
	  return {
	    root: (0, _objectSpread2.default)({}, theme.mixins.toolbar, {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center'
	    }),
	    gutters: theme.mixins.gutters()
	  };
	};
	
	exports.styles = styles;
	
	function Toolbar(props) {
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      disableGutters = props.disableGutters,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableGutters"]);
	  var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.gutters, !disableGutters), classNameProp);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: className
	  }, other), children);
	}
	
	Toolbar.propTypes =  false ? {
	  /**
	   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, disables gutter padding.
	   */
	  disableGutters: _propTypes.default.bool
	} : {};
	Toolbar.defaultProps = {
	  disableGutters: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiToolbar'
	})(Toolbar);
	
	exports.default = _default;

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Toolbar.default;
	  }
	});
	
	var _Toolbar = _interopRequireDefault(__webpack_require__(261));

/***/ }),

/***/ 146:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = {
	  ZERO: 48,
	  NINE: 57,
	
	  NUMPAD_ZERO: 96,
	  NUMPAD_NINE: 105,
	
	  BACKSPACE: 8,
	  DELETE: 46,
	  ENTER: 13,
	
	  ARROW_UP: 38,
	  ARROW_DOWN: 40
	};
	module.exports = exports['default'];

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(23);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(26);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(30);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(29);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _KeyCode = __webpack_require__(146);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Options = function (_React$Component) {
	  (0, _inherits3['default'])(Options, _React$Component);
	
	  function Options(props) {
	    (0, _classCallCheck3['default'])(this, Options);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Options.__proto__ || Object.getPrototypeOf(Options)).call(this, props));
	
	    _this.buildOptionText = function (value) {
	      return value + ' ' + _this.props.locale.items_per_page;
	    };
	
	    _this.changeSize = function (value) {
	      _this.props.changeSize(Number(value));
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState({
	        goInputText: e.target.value
	      });
	    };
	
	    _this.go = function (e) {
	      var val = _this.state.goInputText;
	      if (val === '') {
	        return;
	      }
	      val = isNaN(val) ? _this.props.current : Number(val);
	      if (e.keyCode === _KeyCode2['default'].ENTER || e.type === 'click') {
	        _this.setState({
	          goInputText: ''
	        });
	        _this.props.quickGo(val);
	      }
	    };
	
	    _this.state = {
	      goInputText: ''
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Options, [{
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	      var state = this.state;
	      var locale = props.locale;
	      var prefixCls = props.rootPrefixCls + '-options';
	      var changeSize = props.changeSize;
	      var quickGo = props.quickGo;
	      var goButton = props.goButton;
	      var buildOptionText = props.buildOptionText || this.buildOptionText;
	      var Select = props.selectComponentClass;
	      var changeSelect = null;
	      var goInput = null;
	      var gotoButton = null;
	
	      if (!(changeSize || quickGo)) {
	        return null;
	      }
	
	      if (changeSize && Select) {
	        var Option = Select.Option;
	        var pageSize = props.pageSize || props.pageSizeOptions[0];
	        var options = props.pageSizeOptions.map(function (opt, i) {
	          return _react2['default'].createElement(
	            Option,
	            { key: i, value: opt },
	            buildOptionText(opt)
	          );
	        });
	
	        changeSelect = _react2['default'].createElement(
	          Select,
	          {
	            prefixCls: props.selectPrefixCls,
	            showSearch: false,
	            className: prefixCls + '-size-changer',
	            optionLabelProp: 'children',
	            dropdownMatchSelectWidth: false,
	            value: pageSize.toString(),
	            onChange: this.changeSize,
	            getPopupContainer: function getPopupContainer(triggerNode) {
	              return triggerNode.parentNode;
	            }
	          },
	          options
	        );
	      }
	
	      if (quickGo) {
	        if (goButton) {
	          if (typeof goButton === 'boolean') {
	            gotoButton = _react2['default'].createElement(
	              'button',
	              {
	                type: 'button',
	                onClick: this.go,
	                onKeyUp: this.go
	              },
	              locale.jump_to_confirm
	            );
	          } else {
	            gotoButton = _react2['default'].createElement(
	              'span',
	              {
	                onClick: this.go,
	                onKeyUp: this.go
	              },
	              goButton
	            );
	          }
	        }
	        goInput = _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-quick-jumper' },
	          locale.jump_to,
	          _react2['default'].createElement('input', {
	            type: 'text',
	            value: state.goInputText,
	            onChange: this.handleChange,
	            onKeyUp: this.go
	          }),
	          locale.page,
	          gotoButton
	        );
	      }
	
	      return _react2['default'].createElement(
	        'li',
	        { className: '' + prefixCls },
	        changeSelect,
	        goInput
	      );
	    }
	  }]);
	  return Options;
	}(_react2['default'].Component);
	
	Options.propTypes = {
	  changeSize: _propTypes2['default'].func,
	  quickGo: _propTypes2['default'].func,
	  selectComponentClass: _propTypes2['default'].func,
	  current: _propTypes2['default'].number,
	  pageSizeOptions: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  pageSize: _propTypes2['default'].number,
	  buildOptionText: _propTypes2['default'].func,
	  locale: _propTypes2['default'].object
	};
	Options.defaultProps = {
	  pageSizeOptions: ['10', '20', '30', '40']
	};
	exports['default'] = Options;
	module.exports = exports['default'];

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Pager = function Pager(props) {
	  var prefixCls = props.rootPrefixCls + '-item';
	  var cls = prefixCls + ' ' + prefixCls + '-' + props.page;
	
	  if (props.active) {
	    cls = cls + ' ' + prefixCls + '-active';
	  }
	
	  if (props.className) {
	    cls = cls + ' ' + props.className;
	  }
	
	  var handleClick = function handleClick() {
	    props.onClick(props.page);
	  };
	
	  var handleKeyPress = function handleKeyPress(e) {
	    props.onKeyPress(e, props.onClick, props.page);
	  };
	
	  return _react2['default'].createElement(
	    'li',
	    {
	      title: props.showTitle ? props.page : null,
	      className: cls,
	      onClick: handleClick,
	      onKeyPress: handleKeyPress,
	      tabIndex: '0'
	    },
	    props.itemRender(props.page, 'page', _react2['default'].createElement(
	      'a',
	      null,
	      props.page
	    ))
	  );
	};
	
	Pager.propTypes = {
	  page: _propTypes2['default'].number,
	  active: _propTypes2['default'].bool,
	  last: _propTypes2['default'].bool,
	  locale: _propTypes2['default'].object,
	  className: _propTypes2['default'].string,
	  showTitle: _propTypes2['default'].bool,
	  rootPrefixCls: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  onKeyPress: _propTypes2['default'].func,
	  itemRender: _propTypes2['default'].func
	};
	
	exports['default'] = Pager;
	module.exports = exports['default'];

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(23);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(26);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(30);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(29);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Pager = __webpack_require__(342);
	
	var _Pager2 = _interopRequireDefault(_Pager);
	
	var _Options = __webpack_require__(341);
	
	var _Options2 = _interopRequireDefault(_Options);
	
	var _KeyCode = __webpack_require__(146);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _zh_CN = __webpack_require__(345);
	
	var _zh_CN2 = _interopRequireDefault(_zh_CN);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function isInteger(value) {
	  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
	}
	
	function defaultItemRender(page, type, element) {
	  return element;
	}
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3['default'])(Pagination, _React$Component);
	
	  function Pagination(props) {
	    (0, _classCallCheck3['default'])(this, Pagination);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var hasOnChange = props.onChange !== noop;
	    var hasCurrent = 'current' in props;
	    if (hasCurrent && !hasOnChange) {
	      console.warn('Warning: You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.'); // eslint-disable-line
	    }
	
	    var current = props.defaultCurrent;
	    if ('current' in props) {
	      current = props.current;
	    }
	
	    var pageSize = props.defaultPageSize;
	    if ('pageSize' in props) {
	      pageSize = props.pageSize;
	    }
	
	    _this.state = {
	      current: current,
	      currentInputValue: current,
	      pageSize: pageSize
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Pagination, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ('current' in nextProps) {
	        this.setState({
	          current: nextProps.current,
	          currentInputValue: nextProps.current
	        });
	      }
	
	      if ('pageSize' in nextProps) {
	        var newState = {};
	        var current = this.state.current;
	        var newCurrent = this.calculatePage(nextProps.pageSize);
	        current = current > newCurrent ? newCurrent : current;
	        if (!('current' in nextProps)) {
	          newState.current = current;
	          newState.currentInputValue = current;
	        }
	        newState.pageSize = nextProps.pageSize;
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // When current page change, fix focused style of prev item
	      // A hacky solution of https://github.com/ant-design/ant-design/issues/8948
	      var prefixCls = this.props.prefixCls;
	
	      if (prevState.current !== this.state.current && this.paginationNode) {
	        var lastCurrentNode = this.paginationNode.querySelector('.' + prefixCls + '-item-' + prevState.current);
	        if (lastCurrentNode && document.activeElement === lastCurrentNode) {
	          lastCurrentNode.blur();
	        }
	      }
	    }
	  }, {
	    key: 'getJumpPrevPage',
	    value: function getJumpPrevPage() {
	      return Math.max(1, this.state.current - (this.props.showLessItems ? 3 : 5));
	    }
	  }, {
	    key: 'getJumpNextPage',
	    value: function getJumpNextPage() {
	      return Math.min(this.calculatePage(), this.state.current + (this.props.showLessItems ? 3 : 5));
	    }
	  }, {
	    key: 'getJumpPrevPage',
	    value: function getJumpPrevPage() {
	      return Math.max(1, this.state.current - (this.props.showLessItems ? 3 : 5));
	    }
	  }, {
	    key: 'getJumpNextPage',
	    value: function getJumpNextPage() {
	      return Math.min(this.calculatePage(), this.state.current + (this.props.showLessItems ? 3 : 5));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // When hideOnSinglePage is true and there is only 1 page, hide the pager
	      if (this.props.hideOnSinglePage === true && this.props.total <= this.state.pageSize) {
	        return null;
	      }
	
	      var props = this.props;
	      var locale = props.locale;
	
	      var prefixCls = props.prefixCls;
	      var allPages = this.calculatePage();
	      var pagerList = [];
	      var jumpPrev = null;
	      var jumpNext = null;
	      var firstPager = null;
	      var lastPager = null;
	      var gotoButton = null;
	
	      var goButton = props.showQuickJumper && props.showQuickJumper.goButton;
	      var pageBufferSize = props.showLessItems ? 1 : 2;
	      var _state = this.state,
	          current = _state.current,
	          pageSize = _state.pageSize;
	
	
	      var prevPage = current - 1 > 0 ? current - 1 : 0;
	      var nextPage = current + 1 < allPages ? current + 1 : allPages;
	
	      if (props.simple) {
	        if (goButton) {
	          if (typeof goButton === 'boolean') {
	            gotoButton = _react2['default'].createElement(
	              'button',
	              {
	                type: 'button',
	                onClick: this.handleGoTO,
	                onKeyUp: this.handleGoTO
	              },
	              locale.jump_to_confirm
	            );
	          } else {
	            gotoButton = _react2['default'].createElement(
	              'span',
	              {
	                onClick: this.handleGoTO,
	                onKeyUp: this.handleGoTO
	              },
	              goButton
	            );
	          }
	          gotoButton = _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? '' + locale.jump_to + this.state.current + '/' + allPages : null,
	              className: prefixCls + '-simple-pager'
	            },
	            gotoButton
	          );
	        }
	
	        return _react2['default'].createElement(
	          'ul',
	          { className: prefixCls + ' ' + prefixCls + '-simple ' + props.className, style: props.style },
	          _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? locale.prev_page : null,
	              onClick: this.prev,
	              tabIndex: this.hasPrev() ? 0 : null,
	              onKeyPress: this.runIfEnterPrev,
	              className: (this.hasPrev() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
	              'aria-disabled': !this.hasPrev()
	            },
	            props.itemRender(prevPage, 'prev', _react2['default'].createElement('a', { className: prefixCls + '-item-link' }))
	          ),
	          _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? this.state.current + '/' + allPages : null,
	              className: prefixCls + '-simple-pager'
	            },
	            _react2['default'].createElement('input', {
	              type: 'text',
	              value: this.state.currentInputValue,
	              onKeyDown: this.handleKeyDown,
	              onKeyUp: this.handleKeyUp,
	              onChange: this.handleKeyUp,
	              size: '3'
	            }),
	            _react2['default'].createElement(
	              'span',
	              { className: prefixCls + '-slash' },
	              '\uFF0F'
	            ),
	            allPages
	          ),
	          _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? locale.next_page : null,
	              onClick: this.next,
	              tabIndex: this.hasPrev() ? 0 : null,
	              onKeyPress: this.runIfEnterNext,
	              className: (this.hasNext() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
	              'aria-disabled': !this.hasNext()
	            },
	            props.itemRender(nextPage, 'next', _react2['default'].createElement('a', { className: prefixCls + '-item-link' }))
	          ),
	          gotoButton
	        );
	      }
	
	      if (allPages <= 5 + pageBufferSize * 2) {
	        for (var i = 1; i <= allPages; i++) {
	          var active = this.state.current === i;
	          pagerList.push(_react2['default'].createElement(_Pager2['default'], {
	            locale: locale,
	            rootPrefixCls: prefixCls,
	            onClick: this.handleChange,
	            onKeyPress: this.runIfEnter,
	            key: i,
	            page: i,
	            active: active,
	            showTitle: props.showTitle,
	            itemRender: props.itemRender
	          }));
	        }
	      } else {
	        var prevItemTitle = props.showLessItems ? locale.prev_3 : locale.prev_5;
	        var nextItemTitle = props.showLessItems ? locale.next_3 : locale.next_5;
	        if (props.showPrevNextJumpers) {
	          jumpPrev = _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? prevItemTitle : null,
	              key: 'prev',
	              onClick: this.jumpPrev,
	              tabIndex: '0',
	              onKeyPress: this.runIfEnterJumpPrev,
	              className: prefixCls + '-jump-prev'
	            },
	            props.itemRender(this.getJumpPrevPage(), 'jump-prev', _react2['default'].createElement('a', { className: prefixCls + '-item-link' }))
	          );
	          jumpNext = _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? nextItemTitle : null,
	              key: 'next',
	              tabIndex: '0',
	              onClick: this.jumpNext,
	              onKeyPress: this.runIfEnterJumpNext,
	              className: prefixCls + '-jump-next'
	            },
	            props.itemRender(this.getJumpNextPage(), 'jump-next', _react2['default'].createElement('a', { className: prefixCls + '-item-link' }))
	          );
	        }
	        lastPager = _react2['default'].createElement(_Pager2['default'], {
	          locale: props.locale,
	          last: true,
	          rootPrefixCls: prefixCls,
	          onClick: this.handleChange,
	          onKeyPress: this.runIfEnter,
	          key: allPages,
	          page: allPages,
	          active: false,
	          showTitle: props.showTitle,
	          itemRender: props.itemRender
	        });
	        firstPager = _react2['default'].createElement(_Pager2['default'], {
	          locale: props.locale,
	          rootPrefixCls: prefixCls,
	          onClick: this.handleChange,
	          onKeyPress: this.runIfEnter,
	          key: 1,
	          page: 1,
	          active: false,
	          showTitle: props.showTitle,
	          itemRender: props.itemRender
	        });
	
	        var left = Math.max(1, current - pageBufferSize);
	        var right = Math.min(current + pageBufferSize, allPages);
	
	        if (current - 1 <= pageBufferSize) {
	          right = 1 + pageBufferSize * 2;
	        }
	
	        if (allPages - current <= pageBufferSize) {
	          left = allPages - pageBufferSize * 2;
	        }
	
	        for (var _i = left; _i <= right; _i++) {
	          var _active = current === _i;
	          pagerList.push(_react2['default'].createElement(_Pager2['default'], {
	            locale: props.locale,
	            rootPrefixCls: prefixCls,
	            onClick: this.handleChange,
	            onKeyPress: this.runIfEnter,
	            key: _i,
	            page: _i,
	            active: _active,
	            showTitle: props.showTitle,
	            itemRender: props.itemRender
	          }));
	        }
	
	        if (current - 1 >= pageBufferSize * 2 && current !== 1 + 2) {
	          pagerList[0] = _react2['default'].cloneElement(pagerList[0], {
	            className: prefixCls + '-item-after-jump-prev'
	          });
	          pagerList.unshift(jumpPrev);
	        }
	        if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
	          pagerList[pagerList.length - 1] = _react2['default'].cloneElement(pagerList[pagerList.length - 1], {
	            className: prefixCls + '-item-before-jump-next'
	          });
	          pagerList.push(jumpNext);
	        }
	
	        if (left !== 1) {
	          pagerList.unshift(firstPager);
	        }
	        if (right !== allPages) {
	          pagerList.push(lastPager);
	        }
	      }
	
	      var totalText = null;
	
	      if (props.showTotal) {
	        totalText = _react2['default'].createElement(
	          'li',
	          { className: prefixCls + '-total-text' },
	          props.showTotal(props.total, [(current - 1) * pageSize + 1, current * pageSize > props.total ? props.total : current * pageSize])
	        );
	      }
	      var prevDisabled = !this.hasPrev();
	      var nextDisabled = !this.hasNext();
	      return _react2['default'].createElement(
	        'ul',
	        {
	          className: prefixCls + ' ' + props.className,
	          style: props.style,
	          unselectable: 'unselectable',
	          ref: this.savePaginationNode
	        },
	        totalText,
	        _react2['default'].createElement(
	          'li',
	          {
	            title: props.showTitle ? locale.prev_page : null,
	            onClick: this.prev,
	            tabIndex: prevDisabled ? null : 0,
	            onKeyPress: this.runIfEnterPrev,
	            className: (!prevDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
	            'aria-disabled': prevDisabled
	          },
	          props.itemRender(prevPage, 'prev', _react2['default'].createElement('a', { className: prefixCls + '-item-link' }))
	        ),
	        pagerList,
	        _react2['default'].createElement(
	          'li',
	          {
	            title: props.showTitle ? locale.next_page : null,
	            onClick: this.next,
	            tabIndex: nextDisabled ? null : 0,
	            onKeyPress: this.runIfEnterNext,
	            className: (!nextDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
	            'aria-disabled': nextDisabled
	          },
	          props.itemRender(nextPage, 'next', _react2['default'].createElement('a', { className: prefixCls + '-item-link' }))
	        ),
	        _react2['default'].createElement(_Options2['default'], {
	          locale: props.locale,
	          rootPrefixCls: prefixCls,
	          selectComponentClass: props.selectComponentClass,
	          selectPrefixCls: props.selectPrefixCls,
	          changeSize: this.props.showSizeChanger ? this.changePageSize : null,
	          current: this.state.current,
	          pageSize: this.state.pageSize,
	          pageSizeOptions: this.props.pageSizeOptions,
	          quickGo: this.props.showQuickJumper ? this.handleChange : null,
	          goButton: goButton
	        })
	      );
	    }
	  }]);
	  return Pagination;
	}(_react2['default'].Component);
	
	Pagination.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  current: _propTypes2['default'].number,
	  defaultCurrent: _propTypes2['default'].number,
	  total: _propTypes2['default'].number,
	  pageSize: _propTypes2['default'].number,
	  defaultPageSize: _propTypes2['default'].number,
	  onChange: _propTypes2['default'].func,
	  hideOnSinglePage: _propTypes2['default'].bool,
	  showSizeChanger: _propTypes2['default'].bool,
	  showLessItems: _propTypes2['default'].bool,
	  onShowSizeChange: _propTypes2['default'].func,
	  selectComponentClass: _propTypes2['default'].func,
	  showPrevNextJumpers: _propTypes2['default'].bool,
	  showQuickJumper: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].object]),
	  showTitle: _propTypes2['default'].bool,
	  pageSizeOptions: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  showTotal: _propTypes2['default'].func,
	  locale: _propTypes2['default'].object,
	  style: _propTypes2['default'].object,
	  itemRender: _propTypes2['default'].func
	};
	Pagination.defaultProps = {
	  defaultCurrent: 1,
	  total: 0,
	  defaultPageSize: 10,
	  onChange: noop,
	  className: '',
	  selectPrefixCls: 'rc-select',
	  prefixCls: 'rc-pagination',
	  selectComponentClass: null,
	  hideOnSinglePage: false,
	  showPrevNextJumpers: true,
	  showQuickJumper: false,
	  showSizeChanger: false,
	  showLessItems: false,
	  showTitle: true,
	  onShowSizeChange: noop,
	  locale: _zh_CN2['default'],
	  style: {},
	  itemRender: defaultItemRender
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.savePaginationNode = function (node) {
	    _this2.paginationNode = node;
	  };
	
	  this.calculatePage = function (p) {
	    var pageSize = p;
	    if (typeof pageSize === 'undefined') {
	      pageSize = _this2.state.pageSize;
	    }
	    return Math.floor((_this2.props.total - 1) / pageSize) + 1;
	  };
	
	  this.isValid = function (page) {
	    return isInteger(page) && page >= 1 && page !== _this2.state.current;
	  };
	
	  this.handleKeyDown = function (e) {
	    if (e.keyCode === _KeyCode2['default'].ARROW_UP || e.keyCode === _KeyCode2['default'].ARROW_DOWN) {
	      e.preventDefault();
	    }
	  };
	
	  this.handleKeyUp = function (e) {
	    var inputValue = e.target.value;
	    var currentInputValue = _this2.state.currentInputValue;
	    var value = void 0;
	
	    if (inputValue === '') {
	      value = inputValue;
	    } else if (isNaN(Number(inputValue))) {
	      value = currentInputValue;
	    } else {
	      value = Number(inputValue);
	    }
	
	    if (value !== currentInputValue) {
	      _this2.setState({
	        currentInputValue: value
	      });
	    }
	
	    if (e.keyCode === _KeyCode2['default'].ENTER) {
	      _this2.handleChange(value);
	    } else if (e.keyCode === _KeyCode2['default'].ARROW_UP) {
	      _this2.handleChange(value - 1);
	    } else if (e.keyCode === _KeyCode2['default'].ARROW_DOWN) {
	      _this2.handleChange(value + 1);
	    }
	  };
	
	  this.changePageSize = function (size) {
	    var current = _this2.state.current;
	    var newCurrent = _this2.calculatePage(size);
	    current = current > newCurrent ? newCurrent : current;
	    // fix the issue:
	    // Once 'total' is 0, 'current' in 'onShowSizeChange' is 0, which is not correct.
	    if (newCurrent === 0) {
	      current = _this2.state.current;
	    }
	
	    if (typeof size === 'number') {
	      if (!('pageSize' in _this2.props)) {
	        _this2.setState({
	          pageSize: size
	        });
	      }
	      if (!('current' in _this2.props)) {
	        _this2.setState({
	          current: current,
	          currentInputValue: current
	        });
	      }
	    }
	    _this2.props.onShowSizeChange(current, size);
	  };
	
	  this.handleChange = function (p) {
	    var page = p;
	    if (_this2.isValid(page)) {
	      if (page > _this2.calculatePage()) {
	        page = _this2.calculatePage();
	      }
	
	      if (!('current' in _this2.props)) {
	        _this2.setState({
	          current: page,
	          currentInputValue: page
	        });
	      }
	
	      var pageSize = _this2.state.pageSize;
	      _this2.props.onChange(page, pageSize);
	
	      return page;
	    }
	
	    return _this2.state.current;
	  };
	
	  this.prev = function () {
	    if (_this2.hasPrev()) {
	      _this2.handleChange(_this2.state.current - 1);
	    }
	  };
	
	  this.next = function () {
	    if (_this2.hasNext()) {
	      _this2.handleChange(_this2.state.current + 1);
	    }
	  };
	
	  this.jumpPrev = function () {
	    _this2.handleChange(_this2.getJumpPrevPage());
	  };
	
	  this.jumpNext = function () {
	    _this2.handleChange(_this2.getJumpNextPage());
	  };
	
	  this.hasPrev = function () {
	    return _this2.state.current > 1;
	  };
	
	  this.hasNext = function () {
	    return _this2.state.current < _this2.calculatePage();
	  };
	
	  this.runIfEnter = function (event, callback) {
	    for (var _len = arguments.length, restParams = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      restParams[_key - 2] = arguments[_key];
	    }
	
	    if (event.key === 'Enter' || event.charCode === 13) {
	      callback.apply(undefined, restParams);
	    }
	  };
	
	  this.runIfEnterPrev = function (e) {
	    _this2.runIfEnter(e, _this2.prev);
	  };
	
	  this.runIfEnterNext = function (e) {
	    _this2.runIfEnter(e, _this2.next);
	  };
	
	  this.runIfEnterJumpPrev = function (e) {
	    _this2.runIfEnter(e, _this2.jumpPrev);
	  };
	
	  this.runIfEnterJumpNext = function (e) {
	    _this2.runIfEnter(e, _this2.jumpNext);
	  };
	
	  this.handleGoTO = function (e) {
	    if (e.keyCode === _KeyCode2['default'].ENTER || e.type === 'click') {
	      _this2.handleChange(_this2.state.currentInputValue);
	    }
	  };
	};
	
	exports['default'] = Pagination;
	module.exports = exports['default'];

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Pagination = __webpack_require__(343);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Pagination)['default'];
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = exports['default'];

/***/ }),

/***/ 345:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = {
	  // Options.jsx
	  items_per_page: '条/页',
	  jump_to: '跳至',
	  jump_to_confirm: '确定',
	  page: '页',
	
	  // Pagination.jsx
	  prev_page: '上一页',
	  next_page: '下一页',
	  prev_5: '向前 5 页',
	  next_5: '向后 5 页',
	  prev_3: '向前 3 页',
	  next_3: '向后 3 页'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFacebook = function FaFacebook(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.4 0.3v5.9h-3.5q-1.9 0-2.6 0.8t-0.7 2.4v4.2h6.6l-0.9 6.6h-5.7v16.9h-6.8v-16.9h-5.7v-6.6h5.7v-4.9q0-4.1 2.3-6.4t6.2-2.3q3.3 0 5.1 0.3z' })
	        )
	    );
	};
	
	exports.default = FaFacebook;
	module.exports = exports['default'];

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGooglePlus = function FaGooglePlus(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.2 20.3q0 3.6-1.6 6.5t-4.3 4.4-6.5 1.6q-2.6 0-5-1t-4.1-2.7-2.7-4.1-1-5 1-5 2.7-4.1 4.1-2.7 5-1q5 0 8.6 3.3l-3.5 3.4q-2-2-5.1-2-2.1 0-4 1.1t-2.8 2.9-1.1 4.1 1.1 4.1 2.8 2.9 4 1.1q1.5 0 2.7-0.4t2-1 1.4-1.4 0.8-1.4 0.4-1.3h-7.3v-4.4h12.1q0.3 1.1 0.3 2.1z m15.1-2.1v3.6h-3.6v3.7h-3.7v-3.7h-3.7v-3.6h3.7v-3.7h3.7v3.7h3.6z' })
	        )
	    );
	};
	
	exports.default = FaGooglePlus;
	module.exports = exports['default'];

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPinterestP = function FaPinterestP(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm5.5 13.3q0-2.4 0.8-4.5t2.3-3.7 3.4-2.8 4.2-1.7 4.5-0.6q3.5 0 6.5 1.5t5 4.3 1.9 6.4q0 2.2-0.5 4.2t-1.3 4-2.2 3.3-3.3 2.3-4.2 0.9q-1.5 0-3-0.8t-2.1-1.9q-0.3 0.8-0.7 2.5t-0.5 2.1-0.4 1.6-0.6 1.6-0.7 1.4-1.1 1.7-1.4 1.9l-0.3 0.1-0.2-0.2q-0.3-3.5-0.3-4.2 0-2 0.5-4.6t1.5-6.4 1.1-4.5q-0.7-1.5-0.7-3.8 0-1.9 1.2-3.5t2.9-1.6q1.4 0 2.1 0.9t0.8 2.3q0 1.5-1 4.2t-1 4.2q0 1.4 1 2.3t2.5 1q1.2 0 2.3-0.6t1.7-1.5 1.3-2.1 0.8-2.5 0.4-2.5 0.2-2.2q0-3.9-2.5-6t-6.3-2.2q-4.5 0-7.5 2.9t-3 7.4q0 0.9 0.3 1.9t0.6 1.4 0.6 1 0.3 0.7q0 0.6-0.3 1.6t-0.9 1q0 0-0.3 0-1.2-0.4-2.1-1.3t-1.3-2.1-0.8-2.4-0.2-2.4z' })
	        )
	    );
	};
	
	exports.default = FaPinterestP;
	module.exports = exports['default'];

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTwitter = function FaTwitter(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.7 9.1q-1.5 2.2-3.7 3.7 0.1 0.3 0.1 1 0 2.9-0.9 5.8t-2.6 5.5-4.1 4.7-5.7 3.3-7.2 1.2q-6.1 0-11.1-3.3 0.8 0.1 1.7 0.1 5 0 9-3-2.4-0.1-4.2-1.5t-2.6-3.5q0.8 0.1 1.4 0.1 1 0 1.9-0.3-2.5-0.5-4.1-2.5t-1.7-4.6v0q1.5 0.8 3.3 0.9-1.5-1-2.4-2.6t-0.8-3.4q0-2 0.9-3.7 2.7 3.4 6.6 5.4t8.3 2.2q-0.2-0.9-0.2-1.7 0-3 2.1-5.1t5.1-2.1q3.2 0 5.3 2.3 2.4-0.5 4.6-1.7-0.8 2.5-3.2 3.9 2.1-0.2 4.2-1.1z' })
	        )
	    );
	};
	
	exports.default = FaTwitter;
	module.exports = exports['default'];

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IoSocialInstagram = function IoSocialInstagram(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.8 20c0-4.1 2.1-6.2 6.2-6.2s6.3 2.1 6.3 6.2-2.2 6.3-6.3 6.3-6.2-2.2-6.2-6.3z m0-6.2c-1.1 1.1-1.8 2.3-2.2 3.7h-6.6v-8.7c0-1.1 0.3-2 1.1-2.7s1.7-1.1 2.7-1.1h22.5c1 0 1.9 0.4 2.6 1.1s1.1 1.6 1.1 2.7v8.7h-6.6c-0.4-1.4-1.1-2.6-2.2-3.7-1.7-1.7-3.8-2.5-6.2-2.5s-4.5 0.8-6.2 2.5z m18.7-2.2v-3.1c0-0.3-0.2-0.5-0.3-0.7s-0.4-0.3-0.7-0.3h-3c-0.3 0-0.5 0.2-0.7 0.3s-0.3 0.4-0.3 0.7v3.1c0 0.3 0.2 0.5 0.3 0.7s0.4 0.2 0.7 0.2h3c0.3 0 0.5-0.1 0.7-0.2s0.3-0.4 0.3-0.7z m-6.2 14.6c1.7-1.7 2.5-3.8 2.5-6.2h6.2v11.3c0 1-0.4 1.8-1.1 2.6s-1.6 1.1-2.6 1.1h-22.5c-1 0-1.8-0.3-2.6-1.1s-1.2-1.6-1.2-2.6v-11.3h6.3c0 2.4 0.8 4.5 2.5 6.2s3.8 2.6 6.2 2.6 4.5-0.9 6.3-2.6z' })
	        )
	    );
	};
	
	exports.default = IoSocialInstagram;
	module.exports = exports['default'];

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLazyload = __webpack_require__(348);
	
	var _reactLazyload2 = _interopRequireDefault(_reactLazyload);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Grid = __webpack_require__(41);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Card = __webpack_require__(363);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardContent = __webpack_require__(236);
	
	var _CardContent2 = _interopRequireDefault(_CardContent);
	
	var _CircularProgress = __webpack_require__(238);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _Fade = __webpack_require__(128);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _styleUtils = __webpack_require__(369);
	
	var _formatCategory = __webpack_require__(214);
	
	var _formatCategory2 = _interopRequireDefault(_formatCategory);
	
	var _formatDate = __webpack_require__(133);
	
	var _formatDate2 = _interopRequireDefault(_formatDate);
	
	var _getRandomColor = __webpack_require__(288);
	
	var _getRandomColor2 = _interopRequireDefault(_getRandomColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _circularProgress, _container, _thumbnailWrapped, _contentWrapper, _title, _meta, _metaCategory, _metaTimesWrapper, _metaTimes, _extends2;
	
	  return {
	    circularProgress: (_circularProgress = {
	      display: 'block',
	      margin: 'auto',
	      minHeight: 195
	    }, _circularProgress[theme.breakpoints.down('md')] = {
	      minHeight: 182
	    }, _circularProgress),
	    container: (_container = {
	      marginBottom: 40,
	      overflow: 'hidden',
	      height: 195
	    }, _container[theme.breakpoints.down('md')] = {
	      height: 182
	    }, _container[theme.breakpoints.down('xs')] = {
	      border: '1px solid ' + theme.palette.borders.cloud,
	      height: 'auto',
	      marginBottom: 15
	    }, _container['&:hover'] = {
	      '& img': {
	        transform: 'scale(1.3) rotate(-10deg)'
	      }
	    }, _container),
	    thumbnailWrapped: (_thumbnailWrapped = {
	      width: '100%',
	      height: '100%',
	      overflow: 'hidden'
	    }, _thumbnailWrapped[theme.breakpoints.down('xs')] = {
	      height: 190
	    }, _thumbnailWrapped),
	    thumbnail: {
	      height: '100%',
	      width: '100%',
	      objectFit: 'cover',
	      transition: 'transform 0.5s, opacity 1s ease-in !important'
	    },
	    contentWrapper: (_contentWrapper = {
	      height: '100%',
	      boxShadow: 'none'
	    }, _contentWrapper[theme.breakpoints.down('sm')] = {
	      fontSize: '0.9em'
	    }, _contentWrapper[theme.breakpoints.down('xs')] = {
	      padding: 0
	    }, _contentWrapper),
	    title: (_title = {
	      fontWeight: 500
	    }, _title[theme.breakpoints.down('md')] = {
	      fontSize: '1.25em'
	    }, _title[theme.breakpoints.down('xs')] = {
	      fontSize: '1em'
	    }, _title),
	    meta: (_meta = {
	      color: theme.palette.text.soft,
	      fontStyle: 'italic',
	      fontWeight: 300,
	      opacity: 0.8,
	      width: '100%'
	    }, _meta[theme.breakpoints.down('xs')] = {
	      fontSize: '0.9em',
	      position: 'relative',
	      height: 18
	    }, _meta),
	    metaCategory: (_metaCategory = {
	      color: theme.palette.accent.noticeLight,
	      fontWeight: 500,
	      fontStyle: 'normal',
	      opacity: 0.8,
	      display: 'inline-block'
	    }, _metaCategory[theme.breakpoints.down('md')] = {
	      fontSize: '0.9em'
	    }, _metaCategory[theme.breakpoints.down('xs')] = {
	      position: 'absolute'
	    }, _metaCategory),
	    metaTimesWrapper: (_metaTimesWrapper = {
	      float: 'right'
	    }, _metaTimesWrapper[theme.breakpoints.down('xs')] = {
	      float: 'none',
	      position: 'absolute',
	      right: 0,
	      top: 4
	    }, _metaTimesWrapper),
	    metaTimes: (_metaTimes = {
	      float: 'right',
	      color: theme.palette.text.light
	    }, _metaTimes[theme.breakpoints.down('md')] = {
	      fontSize: '0.85em'
	    }, _metaTimes[theme.breakpoints.down('xs')] = {
	      // display: 'block',
	      fontSize: '0.9em',
	      marginTop: -5,
	      float: 'none',
	      fontStyle: 'normal',
	      textAlign: 'right'
	    }, _metaTimes),
	    excerpt: _extends({
	      color: theme.palette.text.main,
	      lineHeight: 1.8,
	      fontWeight: 300,
	      fontSize: '1em'
	    }, (0, _styleUtils.noTextOverflow)({
	      whiteSpace: 'normal',
	      '&:hover': {}
	    }), (_extends2 = {}, _extends2[theme.breakpoints.down('md')] = {
	      maxHeight: 75,
	      fontSize: '0.9em'
	    }, _extends2[theme.breakpoints.down('xs')] = {
	      fontSize: '0.8em',
	      lineHeight: 1.5,
	      maxHeight: 85,
	      marginTop: 5
	    }, _extends2))
	  };
	};
	
	var Article = function Article(_ref) {
	  var index = _ref.index,
	      id = _ref.id,
	      classes = _ref.classes,
	      slug = _ref.slug,
	      timeToRead = _ref.timeToRead,
	      title = _ref.title,
	      uiTitle = _ref.uiTitle,
	      date = _ref.date,
	      src = _ref.src,
	      excerpt = _ref.excerpt,
	      category = _ref.category,
	      pageType = _ref.pageType;
	
	  var rootProps = {};
	  if (id) {
	    rootProps.id = id;
	  }
	
	  var pageProps = {};
	  var categoryProps = {};
	
	  if (pageType === 'review') {
	    pageProps.title = uiTitle;
	    pageProps.category = 'Review';
	  } else {
	    pageProps.title = title;
	    pageProps.category = category;
	    categoryProps.component = _gatsbyLink2.default;
	    categoryProps.to = '/' + category;
	  }
	
	  var Image = function Image(props) {
	    return _react2.default.createElement('img', props);
	  }; // Fade passes in mandatory style prop
	
	  var color = (0, _getRandomColor2.default)();
	
	  return _react2.default.createElement(
	    _Grid2.default,
	    _extends({}, rootProps, {
	      classes: { container: classes.container },
	      spacing: 0,
	      container: true
	    }),
	    _react2.default.createElement(
	      _Grid2.default,
	      { xs: 12, sm: 4, item: true },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: slug },
	        src && _react2.default.createElement(
	          'div',
	          { className: classes.thumbnailWrapped },
	          _react2.default.createElement(
	            _reactLazyload2.default,
	            {
	              placeholder: _react2.default.createElement(_CircularProgress2.default, {
	                className: classes.circularProgress,
	                style: { color: color },
	                size: 150,
	                thickness: 1
	              }),
	              once: true
	            },
	            _react2.default.createElement(
	              _Fade2.default,
	              { timeout: 2000, 'in': true },
	              _react2.default.createElement(Image, {
	                src: src,
	                className: classes.thumbnail,
	                alt: pageProps.title,
	                title: pageProps.title
	              })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Grid2.default,
	      { xs: 12, sm: 8, item: true },
	      _react2.default.createElement(
	        _Card2.default,
	        { className: classes.contentWrapper },
	        _react2.default.createElement(
	          _CardContent2.default,
	          null,
	          _react2.default.createElement(
	            _Typography2.default,
	            {
	              variant: 'headline',
	              classes: { root: classes.title },
	              component: _gatsbyLink2.default,
	              to: slug,
	              gutterBottom: true
	            },
	            pageProps.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: classes.meta },
	            _react2.default.createElement(
	              _Typography2.default,
	              _extends({}, categoryProps, {
	                variant: 'subheading',
	                classes: { root: classes.metaCategory }
	              }),
	              pageType === 'review' ? 'Review' : (0, _formatCategory2.default)(category),
	              ' '
	            ),
	            ' ',
	            _react2.default.createElement(
	              'div',
	              { className: classes.metaTimesWrapper },
	              _react2.default.createElement(
	                _Typography2.default,
	                { classes: { root: classes.metaTimes } },
	                (0, _formatDate2.default)(date, 'MMMM Do'),
	                ' ',
	                '\u2022',
	                ' ',
	                timeToRead,
	                ' min read'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { classes: { root: classes.excerpt } },
	            excerpt
	          )
	        )
	      )
	    )
	  );
	};
	
	Article.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  index: _propTypes2.default.number,
	  slug: _propTypes2.default.string.isRequired,
	  timeToRead: _propTypes2.default.number.isRequired,
	  excerpt: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  uiTitle: _propTypes2.default.string,
	  date: _propTypes2.default.string.isRequired,
	  src: _propTypes2.default.string.isRequired,
	  category: _propTypes2.default.string,
	  pageType: _propTypes2.default.string
	};
	
	exports.default = (0, _withStyles2.default)(styles)(Article);
	module.exports = exports['default'];

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _AppBar = __webpack_require__(155);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	var _Toolbar = __webpack_require__(262);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _rcPagination = __webpack_require__(344);
	
	var _rcPagination2 = _interopRequireDefault(_rcPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _pagination;
	
	  return {
	    appBar: {
	      background: 'none',
	      boxShadow: 'none'
	    },
	    pagination: (_pagination = {
	      '& > li': {
	        marginBottom: 3,
	        border: '1px solid ' + theme.palette.borders.cloudier,
	        borderRadius: '50%',
	        background: theme.palette.primary.main,
	        transition: 'background 0.5s',
	        '&:hover': {
	          background: theme.palette.background.light
	        },
	        '& > a': {
	          transition: 'color 0.5s',
	          color: '#fff',
	          '&:hover': {
	            color: theme.palette.primary.main
	          }
	        }
	      }
	    }, _pagination[theme.breakpoints.down('xs')] = {
	      transform: 'scale(0.75)',
	      width: '100%',
	      '& > li': {
	        marginRight: 2
	      }
	    }, _pagination)
	  };
	};
	
	var ArticlesPagination = function (_React$Component) {
	  _inherits(ArticlesPagination, _React$Component);
	
	  function ArticlesPagination() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ArticlesPagination);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      pageSize: 6
	    }, _this.componentDidMount = function () {
	      return _this.setState({ pageSize: _this.props.itemsPerPage || 6 });
	    }, _this.onPageChange = function (current) {
	      var prefix = _this.props.prefix;
	
	      var baseUrl = (0, _gatsbyLink.withPrefix)(prefix);
	      (0, _gatsbyLink.navigateTo)(baseUrl + (current !== 1 ? '/' + current : ''));
	    }, _this.onShowSizeChange = function (current, pageSize) {
	      return _this.setState({ pageSize: pageSize });
	    }, _this.itemRenderer = function (current, type) {
	      var _this$props = _this.props,
	          prefix = _this$props.prefix,
	          currentPage = _this$props.currentPage;
	
	      if (type === 'prev') {
	        return _react2.default.createElement(_gatsbyLink2.default, { to: prefix + '/' + current });
	      }
	      if (type === 'page') {
	        return _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            title: 'Go to page: ' + current,
	            to: prefix + (current !== 1 ? '/' + current : ''),
	            style: {
	              color: currentPage === current ? '#ffa800' : '#fff'
	            }
	          },
	          current
	        );
	      }
	      if (type === 'next') {
	        return _react2.default.createElement(_gatsbyLink2.default, { to: prefix + '/' + current });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ArticlesPagination.prototype.render = function render() {
	    var _props = this.props,
	        classes = _props.classes,
	        currentPage = _props.currentPage,
	        totalItems = _props.totalItems,
	        itemsPerPage = _props.itemsPerPage;
	    var state = this.state;
	
	    return _react2.default.createElement(
	      _AppBar2.default,
	      { position: 'static', classes: { root: classes.appBar } },
	      _react2.default.createElement(
	        _Toolbar2.default,
	        { style: { margin: 'auto', padding: 0 } },
	        _react2.default.createElement(_rcPagination2.default, {
	          current: currentPage,
	          total: totalItems,
	          pageSize: state.pageSize,
	          pageSizeOptions: ['6', '12', '24', '48'],
	          onChange: this.onPageChange,
	          className: classes.pagination,
	          itemRender: this.itemRenderer,
	          onShowSizeChange: this.onShowSizeChange
	        })
	      )
	    );
	  };
	
	  return ArticlesPagination;
	}(_react2.default.Component);
	
	ArticlesPagination.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  currentPage: _propTypes2.default.number.isRequired,
	  totalItems: _propTypes2.default.number.isRequired,
	  itemsPerPage: _propTypes2.default.number.isRequired,
	  prefix: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _withStyles2.default)(styles)(ArticlesPagination);
	module.exports = exports['default'];

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(49);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _pinterestP = __webpack_require__(149);
	
	var _pinterestP2 = _interopRequireDefault(_pinterestP);
	
	var _twitter = __webpack_require__(150);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _socialInstagram = __webpack_require__(346);
	
	var _socialInstagram2 = _interopRequireDefault(_socialInstagram);
	
	var _googlePlus = __webpack_require__(148);
	
	var _googlePlus2 = _interopRequireDefault(_googlePlus);
	
	var _facebook = __webpack_require__(147);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _Section = __webpack_require__(173);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _ConnectItem = __webpack_require__(519);
	
	var _ConnectItem2 = _interopRequireDefault(_ConnectItem);
	
	var _goToUrl = __webpack_require__(289);
	
	var _goToUrl2 = _interopRequireDefault(_goToUrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Connect = function Connect(_ref) {
	  var header = _ref.header;
	
	  var items = [{ Icon: _pinterestP2.default, url: ("https://www.pinterest.com/healthfulinspired/"), title: 'Pinterest' }, { Icon: _facebook2.default, url: ("https://www.facebook.com/healthfulinspired/"), title: 'Facebook' }, { Icon: _twitter2.default, url: ("https://twitter.com/healthfulinspir/"), title: 'Twitter' }, {
	    Icon: _socialInstagram2.default,
	    url: ("https://www.instagram.com/healthfulinspired/"),
	    title: 'Instagram'
	  }, {
	    Icon: _googlePlus2.default,
	    url: ("https://plus.google.com/u/0/115535737505938510496/"),
	    title: 'Google Plus'
	  }];
	  return _react2.default.createElement(_Section2.default, {
	    header: header,
	    render: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        items.map(function (_ref2, i) {
	          var Icon = _ref2.Icon,
	              url = _ref2.url,
	              title = _ref2.title;
	          return _react2.default.createElement(_ConnectItem2.default, {
	            key: 'socialMediaSidebarItem' + i,
	            Icon: Icon,
	            url: url,
	            title: title,
	            onClick: (0, _goToUrl2.default)(url)
	          });
	        })
	      );
	    }
	  });
	};
	
	exports.default = (0, _pure2.default)(Connect);
	module.exports = exports['default'];

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compose = __webpack_require__(47);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _pure = __webpack_require__(49);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    item: {
	      position: 'relative',
	      minHeight: 40,
	      paddingLeft: 7,
	      cursor: 'pointer',
	      transition: 'background 1s',
	      marginBottom: 5,
	      border: '1px solid ' + theme.palette.borders.cloud,
	      '&:hover': {
	        background: theme.palette.secondary.main
	      }
	    },
	    pinterest: { '&:hover': { background: theme.palette.social.pinterest } },
	    twitter: { '&:hover': { background: theme.palette.social.twitter } },
	    instagram: { '&:hover': { background: theme.palette.social.instagram } },
	    tumblr: { '&:hover': { background: theme.palette.social.tumblr } },
	    googleplus: { '&:hover': { background: theme.palette.social.googleplus } },
	    socialMediaName: {
	      fontWeight: 300,
	      position: 'absolute',
	      display: 'flex',
	      width: '100%',
	      alignItems: 'center',
	      height: '100%',
	      color: theme.palette.text.main,
	      transition: 'color 0.5s'
	    },
	    iconContainer: {
	      paddingRight: 6,
	      position: 'absolute',
	      display: 'flex',
	      alignItems: 'center',
	      height: '100%',
	      right: 0
	    },
	    icon: {
	      color: theme.palette.primary.main,
	      fontSize: '1.2em',
	      borderWidth: 2,
	      opacity: 0.9,
	      display: 'flex',
	      alignItems: 'center',
	      transition: 'opacity 0.5s'
	    }
	  };
	};
	
	var SocialIcon = function SocialIcon(_ref) {
	  var Icon = _ref.Icon,
	      url = _ref.url,
	      title = _ref.title,
	      className = _ref.className;
	
	  if (!Icon) {
	    throw new Error('You must provide a social media icon.');
	  }
	  if (!url) {
	    throw new Error('Please provide a URL to redirect to.');
	  }
	
	  return _react2.default.createElement(
	    'a',
	    { href: url, target: '_blank', style: { margin: '0 4px' }, title: title },
	    _react2.default.createElement(Icon, { className: className })
	  );
	};
	SocialIcon.propTypes = {
	  Icon: _propTypes2.default.any.isRequired,
	  url: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  className: _propTypes2.default.string.isRequired
	};
	
	var EnhancedSocialIcon = (0, _pure2.default)(SocialIcon);
	
	var ConnectItem = function ConnectItem(_ref2) {
	  var classes = _ref2.classes,
	      Icon = _ref2.Icon,
	      url = _ref2.url,
	      title = _ref2.title,
	      onClick = _ref2.onClick;
	  return _react2.default.createElement(
	    'div',
	    {
	      onClick: onClick,
	      className: classes.item + ' ' + classes[title.toLowerCase().replace(' ', '')]
	    },
	    _react2.default.createElement(
	      _Typography2.default,
	      { variant: 'body1', classes: { body1: classes.socialMediaName } },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: classes.iconContainer },
	      _react2.default.createElement(EnhancedSocialIcon, {
	        Icon: Icon,
	        url: url,
	        title: title,
	        className: classes.icon
	      })
	    ),
	    _react2.default.createElement(
	      'style',
	      null,
	      '\n      .' + classes.item + ':hover .' + classes.socialMediaName + ' {\n        color: #fff;\n      }\n      .' + classes.item + ':hover .' + classes.icon + ' {\n        color: #fff;\n      }\n    '
	    )
	  );
	};
	
	// prettier-ignore
	exports.default = (0, _compose2.default)(_pure2.default, (0, _withStyles2.default)(styles))(ConnectItem);
	module.exports = exports['default'];

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _List = __webpack_require__(250);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(444);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListItemText = __webpack_require__(446);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	var _Avatar = __webpack_require__(422);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Section = __webpack_require__(173);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    story: {
	      transition: 'opacity 0.8s',
	      padding: 0,
	      marginBottom: 8,
	      '&:hover': {
	        opacity: 0.5
	      }
	    },
	    storyFrom: {
	      color: theme.palette.featured.onWhite
	    },
	    title: {
	      fontWeight: 400,
	      fontSize: '0.8em'
	    }
	  };
	};
	
	var FeaturedStories = function FeaturedStories(_ref) {
	  var classes = _ref.classes,
	      header = _ref.header,
	      stories = _ref.stories;
	
	  var thumbRatio = { width: 70, height: 70 };
	
	  return stories ? _react2.default.createElement(_Section2.default, {
	    header: header,
	    render: function render() {
	      return _react2.default.createElement(
	        _List2.default,
	        null,
	        stories.edges.map(function (_ref2, i) {
	          var node = _ref2.node;
	          return _react2.default.createElement(
	            _ListItem2.default,
	            {
	              key: 'featuredStories' + (i + 1),
	              component: _gatsbyLink2.default,
	              to: node.fields.slug,
	              className: classes.story
	            },
	            _react2.default.createElement(_Avatar2.default, {
	              component: function component(props) {
	                return _react2.default.createElement(
	                  'div',
	                  _extends({}, props, { style: thumbRatio }),
	                  _react2.default.createElement('img', {
	                    src: node.frontmatter.thumbnail,
	                    alt: '',
	                    title: node.frontmatter.title,
	                    style: _extends({}, thumbRatio, {
	                      borderRadius: '50%',
	                      objectFit: 'cover'
	                    })
	                  })
	                );
	              }
	            }),
	            _react2.default.createElement(_ListItemText2.default, {
	              primary: node.frontmatter.storyFrom,
	              secondary: node.frontmatter.title,
	              classes: {
	                primary: classes.storyFrom,
	                secondary: classes.title
	              }
	            })
	          );
	        })
	      );
	    }
	  }) : null;
	};
	
	FeaturedStories.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  header: _propTypes2.default.string.isRequired,
	  stories: _propTypes2.default.object
	};
	
	exports.default = (0, _withStyles2.default)(styles)(FeaturedStories);
	module.exports = exports['default'];

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(49);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _Tags = __webpack_require__(287);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	var _Section = __webpack_require__(173);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopularTags = function PopularTags(_ref) {
	  var header = _ref.header,
	      tags = _ref.tags;
	
	  var tagsWithCounters = generateCounts(accumulateTags(tags));
	
	  var top20Tags = Object.keys(tagsWithCounters).sort(function (a, b) {
	    var tagA = tagsWithCounters[a];
	    var tagB = tagsWithCounters[b];
	    return tagB - tagA;
	  }).slice(0, 20);
	
	  return _react2.default.createElement(_Section2.default, { header: header, render: function render() {
	      return _react2.default.createElement(_Tags2.default, { tags: top20Tags });
	    } });
	};
	
	PopularTags.propTypes = {
	  header: _propTypes2.default.string.isRequired,
	  tags: _propTypes2.default.array
	};
	
	function accumulateTags(allTags) {
	  return allTags.reduce(function (acc, node) {
	    var tags = !!node && 'node' in node ? node.node : node;
	    acc.push.apply(acc, tags.frontmatter.tags);
	    return acc;
	  }, []);
	}
	
	// items = string[]
	function generateCounts(items) {
	  if (!Array.isArray(items)) {
	    throw new Error('You must pass in an iterator in order to generate counts');
	  }
	
	  return items.reduce(function (acc, item) {
	    var copyAcc = _extends({}, acc);
	    if (!copyAcc[item]) copyAcc[item] = 0;
	    typeof copyAcc[item] === 'number' && copyAcc[item]++; // eslint-disable-line
	    return copyAcc;
	  }, {});
	}
	
	exports.default = (0, _pure2.default)(PopularTags);
	module.exports = exports['default'];

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _compose = __webpack_require__(47);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _Phaser = __webpack_require__(132);
	
	var _Phaser2 = _interopRequireDefault(_Phaser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    section: {
	      minHeight: 100,
	      marginBottom: 45
	    },
	    header: {
	      display: 'block'
	    },
	    subheader: {
	      color: theme.palette.secondary.main,
	      fontWeight: 500,
	      fontStyle: 'italic'
	    }
	  };
	};
	
	var SidebarSection = function SidebarSection(_ref) {
	  var classes = _ref.classes,
	      theme = _ref.theme,
	      render = _ref.render,
	      header = _ref.header,
	      subheader = _ref.subheader;
	  return _react2.default.createElement(
	    'div',
	    { className: classes.section },
	    _react2.default.createElement(
	      'div',
	      { className: classes.header },
	      _react2.default.createElement(_Phaser2.default, { color: theme.palette.primary.main, label: header }),
	      subheader && _react2.default.createElement(
	        _Typography2.default,
	        {
	          className: classes.subheader,
	          variant: 'caption',
	          gutterBottom: true
	        },
	        subheader
	      )
	    ),
	    render()
	  );
	};
	
	SidebarSection.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  theme: _propTypes2.default.object.isRequired,
	  render: _propTypes2.default.func.isRequired,
	  header: _propTypes2.default.string
	
	  // prettier-ignore
	};exports.default = (0, _compose2.default)((0, _withStyles2.default)(styles, { withTheme: true }))(SidebarSection);
	module.exports = exports['default'];

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compose = __webpack_require__(47);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _PopularTags = __webpack_require__(521);
	
	var _PopularTags2 = _interopRequireDefault(_PopularTags);
	
	var _Connect = __webpack_require__(518);
	
	var _Connect2 = _interopRequireDefault(_Connect);
	
	var _FeaturedStories = __webpack_require__(520);
	
	var _FeaturedStories2 = _interopRequireDefault(_FeaturedStories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      color: theme.palette.primary.dark
	    },
	    linkText: {
	      fontFamily: 'Roboto',
	      fontSize: '0.9em'
	    },
	    latestPostsHeader: {
	      color: theme.palette.primary.main
	    },
	    readMoreLink: {
	      color: theme.palette.primary.main,
	      textTransform: 'uppercase',
	      fontSize: '0.9em'
	    }
	  };
	};
	
	var Sidebar = function Sidebar(_ref) {
	  var classes = _ref.classes,
	      theme = _ref.theme,
	      posts = _ref.posts,
	      tags = _ref.tags,
	      featuredStories = _ref.featuredStories;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.root },
	    _react2.default.createElement(_Connect2.default, { header: 'Connect' }),
	    tags && _react2.default.createElement(_PopularTags2.default, { header: 'Hot Tags', tags: tags }),
	    _react2.default.createElement(_FeaturedStories2.default, { header: 'Featured Stories', stories: featuredStories }),
	    _react2.default.createElement(
	      'style',
	      null,
	      '\n        a {\n          color: ' + theme.palette.primary.main + ';\n        }\n      '
	    )
	  );
	};
	
	Sidebar.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  theme: _propTypes2.default.object.isRequired,
	  posts: _propTypes2.default.array,
	  tags: _propTypes2.default.array,
	  featuredStories: _propTypes2.default.object,
	  thumbResolutions: _propTypes2.default.object
	
	  // prettier-ignore
	};exports.default = (0, _compose2.default)((0, _withStyles2.default)(styles, { withTheme: true }))(Sidebar);
	module.exports = exports['default'];

/***/ }),

/***/ 985:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Grid = __webpack_require__(41);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Meta = __webpack_require__(48);
	
	var _Sidebar = __webpack_require__(522);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _ArticleItem = __webpack_require__(286);
	
	var _ArticleItem2 = _interopRequireDefault(_ArticleItem);
	
	var _Phaser = __webpack_require__(132);
	
	var _Phaser2 = _interopRequireDefault(_Phaser);
	
	var _ArticlesPagination = __webpack_require__(516);
	
	var _ArticlesPagination2 = _interopRequireDefault(_ArticlesPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _latestPosts, _sidebar;
	
	  return {
	    root: {
	      padding: '15px 0'
	    },
	    latestPosts: (_latestPosts = {
	      width: 950
	    }, _latestPosts[theme.breakpoints.down('md')] = {
	      width: 670
	    }, _latestPosts[theme.breakpoints.down('sm')] = {
	      width: '90%'
	    }, _latestPosts[theme.breakpoints.down('xs')] = {}, _latestPosts),
	    sidebar: (_sidebar = {
	      width: 300
	    }, _sidebar[theme.breakpoints.down('md')] = {
	      width: 280
	    }, _sidebar[theme.breakpoints.down('sm')] = {
	      display: 'none'
	    }, _sidebar)
	  };
	};
	
	var ArticlesPage = function ArticlesPage(_ref) {
	  var classes = _ref.classes,
	      theme = _ref.theme,
	      data = _ref.data,
	      pathContext = _ref.pathContext;
	  var siteMetadata = data.site.siteMetadata,
	      tags = data.tags.edges,
	      featuredStories = data.featuredStories;
	  var group = pathContext.group,
	      index = pathContext.index,
	      pageCount = pathContext.pageCount;
	
	
	  return _react2.default.createElement(
	    _Grid2.default,
	    {
	      classes: { container: classes.root },
	      spacing: 24,
	      justify: 'center',
	      container: true
	    },
	    _react2.default.createElement(_Meta.RootMeta, {
	      url: siteMetadata.siteUrl,
	      title: 'Articles | ' + siteMetadata.siteName,
	      description: siteMetadata.siteDescription,
	      breadCrumb: [{
	        url: siteMetadata.siteUrl + '/weight-loss-articles',
	        name: 'Articles'
	      }]
	    }),
	    _react2.default.createElement(
	      _Grid2.default,
	      { classes: { item: classes.latestPosts }, item: true },
	      _react2.default.createElement(_Phaser2.default, {
	        offset: 15,
	        label: 'Latest Articles',
	        color: theme.palette.primary.main,
	        upperCase: true
	      }),
	      group.map(function (article) {
	        return _react2.default.createElement(_ArticleItem2.default, {
	          key: article.fields.slug,
	          slug: article.fields.slug,
	          timeToRead: article.timeToRead,
	          title: article.frontmatter.title,
	          date: article.frontmatter.date,
	          src: article.frontmatter.thumbnail,
	          excerpt: article.excerpt,
	          category: article.frontmatter.category
	        });
	      }),
	      _react2.default.createElement(_ArticlesPagination2.default, {
	        currentPage: index,
	        totalItems: group.length * pageCount,
	        itemsPerPage: group.length,
	        prefix: '/weight-loss-articles'
	      })
	    ),
	    _react2.default.createElement(
	      _Grid2.default,
	      { classes: { item: classes.sidebar }, item: true },
	      _react2.default.createElement(_Sidebar2.default, { posts: group, tags: tags, featuredStories: featuredStories })
	    )
	  );
	};
	
	ArticlesPage.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.object.isRequired,
	  pathContext: _propTypes2.default.object.isRequired
	
	  // prettier-ignore
	  // eslint-disable-next-line
	};var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = (0, _withStyles2.default)(styles, { withTheme: true })(ArticlesPage);

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function formatCategory(category) {
	  if (typeof category !== 'string') {
	    throw new Error('Category cannot be empty');
	  }
	  var categoryStripped = category.replace(/\//g, '');
	
	  switch (categoryStripped) {
	    case 'health-wellness':
	      return 'Wellness';
	    case 'health-fitness':
	      return 'Fitness';
	    case 'health-food':
	      return 'Food';
	    default:
	      return null;
	  }
	}
	
	exports.default = formatCategory;
	module.exports = exports['default'];

/***/ }),

/***/ 288:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var getRandomColor = function getRandomColor() {
	  var letters = '0123456789ABCDEF';
	  var color = '#';
	  for (var i = 0; i < 6; i++) {
	    color += letters[Math.floor(Math.random() * 16)];
	  }
	  return color;
	};
	
	exports.default = getRandomColor;
	module.exports = exports['default'];

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _gatsbyLink = __webpack_require__(28);
	
	function goToUrl(url) {
	  return function () {
	    if (/^http/.test(url)) {
	      // eslint-disable-next-line
	      return window.open(url, '_blank');
	    }
	    return (0, _gatsbyLink.navigateTo)(url);
	  };
	}
	
	exports.default = goToUrl;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-articles-js-4ae7c7a5a35201b23c50.js